export type SeatCapacity = { max_learners: number; used: number; available: number };

export type SeatSummary = { max: number; used: number; available: number; full: boolean; unassigned: number };

/** Server capacity (learner_seat_capacity RPC) is authoritative; UI only derives display values. */
export function summarizeSeats(cap: SeatCapacity | null | undefined): SeatSummary {
  if (!cap) return { max: 0, used: 0, available: 0, full: true, unassigned: 0 };
  const max = Math.max(0, cap.max_learners | 0);
  const used = Math.max(0, cap.used | 0);
  const available = Math.max(0, cap.available | 0);
  return { max, used, available, full: available === 0, unassigned: available };
}
